<template>
  <div ref="container">
    <a-modal :title="title" :width="1200" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <a-table :dataSource="dataSource" :pagination="pagination" :columns="columns" :loading="loading">
        <template slot="customRenderFlag" slot-scope="status">
          <a-tag v-if="status===0" color="green">启用</a-tag>
          <a-tag v-if="status===2" color="orange">禁用</a-tag>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { getByMaterialId } from '@/api/api'
export default {
  name: 'VendorModal',
  data() {
    return {
      title: '出库统计详情',
      visible: false,
      model: {},
      pagination: {
        current: 1,
        pageSize: 10,
        onChange: this.handlePageChange,
      },
      dataSource: [],
      loading: false,
      columns: [
        {
          title: '产品码',
          dataIndex: 'code',
          width: 200,
        },
        {
          title: '防伪名称',
          dataIndex: 'pname',
        },
        {
          title: '产品名称',
          dataIndex: 'name',
        },
        {
          title: 'UDI名称',
          dataIndex: 'udiName',
        },
        {
          title: '数量',
          dataIndex: 'quantity',
        },
        {
          title: '包装详情',
          dataIndex: 'quantitySpec',
        },
        // {
        //   title: '电话号码',
        //   dataIndex: 'phonenum',
        // },
        // {
        //   title: '排序',
        //   dataIndex: 'userBlngOrgaDsplSeq',
        // },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   width: 60,
        //   align: 'center',
        //   scopedSlots: { customRender: 'customRenderFlag' },
        // },
      ],
    }
  },
  created() {},
  methods: {
    async add(e) {
      console.log(e, 'e122')
      this.visible = true
      this.pagination.current = 1
      this.loading = true

      const res = await getByMaterialId({ number: e.number })
      console.log(res, 'res')
      if (res.code == 200) {
        this.loading = false
        this.dataSource = res.data
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel() {
      this.close()
    },
    handlePageChange(page, pageSize) {
      console.log(page, 'page')
      console.log(pageSize, 'pageSize')
      this.pagination.current = page
    },
  },
}
</script>
<style scoped>
</style>